module.exports = __webpack_public_path__ + "static/media/23_A.c6596cd9.png";